import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export function InfoLayout({ title, subtitle, children, testId }) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-12 sm:px-6 lg:px-8" data-testid={testId}>
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-950 sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-2 text-slate-500">{subtitle}</p>}
        <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-slate-600">{children}</div>
      </main>
      <Footer />
    </div>
  );
}

export function InfoSection({ heading, children }) {
  return (
    <section>
      <h2 className="font-display text-lg font-bold text-slate-900">{heading}</h2>
      <div className="mt-2 space-y-2">{children}</div>
    </section>
  );
}
